<template>
  <section :class="$style['poster']" aria-labelledby="poster-title">
    <h2 id="poster-title" :class="$style['poster__title']">De affiche van {{ title }}</h2>
    <picture :class="$style['poster__picture']">
      <source media="(width <= 48rem)" :srcset="poster.tall.srcset" sizes="100vw" :width="poster.tall.width" :height="poster.tall.height">
      <img
        :src="poster.wide.srcset.split(' ')[0]"
        :srcset="poster.wide.srcset"
        sizes="100vw"
        :width="poster.wide.width"
        :height="poster.wide.height"
        :alt="poster.alt"
        loading="lazy"
        decoding="async"
        :class="$style['poster__image']">
    </picture>
    <!-- Over the dark band at the bottom of the photo, like the printed banner, so the top stays clear for the
         header; on phones the logo overlaps the bottom of the photo and the dates follow under it -->
    <div :class="$style['poster__bar']">
      <img :src="logo.src" :width="logo.width" :height="logo.height" alt="" loading="lazy" :class="$style['poster__logo']">
      <div :class="$style['poster__info']">
        <p :class="$style['poster__when']">{{ when }}</p>
        <p :class="$style['poster__where']">Schouwburg Hengelo</p>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
// The campaign photo of the new show, full width, with its logo and the dates as real text
defineProps<{
  title: string
  when: string
  logo: { src: string, width: number, height: number }
  poster: {
    wide: { srcset: string, width: number, height: number }
    tall: { srcset: string, width: number, height: number }
    alt: string
  }
}>()
</script>
<style module>
.poster {
  position: relative;
  background: var(--stage-black);
  color: var(--stage-white);
}

.poster__title {
  position: absolute;
  width: var(--stage-hairline);
  height: var(--stage-hairline);
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.poster__picture,
.poster__image {
  display: block;
  width: 100%;
  height: auto;
}

.poster__bar {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--spacing-xl) var(--spacing-xxl);
  padding: var(--stage-section) var(--stage-gutter) clamp(1.5rem, 1rem + 2vw, 3rem);
  background: linear-gradient(to top, oklch(0% 0 0deg / 80%), oklch(0% 0 0deg / 0%));
}

.poster__logo {
  display: block;
  width: clamp(16rem, 8rem + 24vw, 34rem);
  max-width: 100%;
  height: auto;
}

.poster__info {
  display: grid;
  justify-items: end;
  gap: var(--spacing);
  text-align: right;
}

.poster__when,
.poster__where {
  margin: 0;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: clamp(1.25rem, 0.8rem + 1.6vw, 2.25rem);
  line-height: 1;
  letter-spacing: -0.01em;
  text-transform: uppercase;
}

.poster__when {
  color: var(--primary-color);
}

@media (width <= 48rem) {
  .poster__bar {
    position: static;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 0;
    background: none;
  }

  .poster__logo {
    position: relative;
    width: 100%;
    margin-top: calc(-0.18 * (100vw - 2 * var(--stage-gutter)));
  }

  .poster__info {
    justify-items: start;
    text-align: left;
  }
}
</style>
